import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-4 bg-brand-navy" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <FadeIn data-id="element-169">
          <div className="bg-gradient-to-br from-brand-slate to-brand-navy border border-brand-gold/20 p-10 md:p-14 rounded-3xl text-center relative overflow-hidden" data-id="element-170">
            {/* Subtle glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-brand-gold/5 blur-3xl pointer-events-none" data-id="element-171" />

            <div className="flex justify-center gap-2 mb-8" data-id="element-172">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-brand-gold fill-brand-gold" data-id="element-173" />)}
            </div>

            <h2 className="text-2xl md:text-4xl font-playfair font-bold text-brand-cream leading-tight mb-8" data-id="element-174">
              "En solo 7 días, las madres que aplican El Código del Silencio
              reportan una{' '}
              <span className="text-brand-gold" data-id="element-175">
                reducción del 60% en los gritos
              </span>{' '}
              en el hogar."
            </h2>

            <p className="text-lg md:text-xl text-brand-gray/90 font-light" data-id="element-176">
              No porque el adolescente se haya vuelto un santo, sino porque{' '}
              <strong className="text-brand-cream font-medium" data-id="element-177">
                tú te has vuelto imperturbable.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}